import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OfflineDetectionService {
  private isOfflineSubject = new BehaviorSubject<boolean>(!navigator.onLine);
  public isOffline$: Observable<boolean> = this.isOfflineSubject.asObservable();

  constructor() {
    // Poll every 3 seconds
    interval(3000).pipe(
      map(() => !navigator.onLine),
      distinctUntilChanged()
    ).subscribe(isOffline => {
      this.isOfflineSubject.next(isOffline);
    });
  }
}
